// アプリユーザAPI.
// キーを変えるため通常のMoffAPIとはActionは分割.
import * as AppUser from '../constants/AppUser';
import { AppUserAPI } from '../api/AppUser';
import * as  MoffAPI from './MoffAPI';
import { Type } from '../components/UserListField';

/**
 * 居宅訪問 or 興味関心チェックの登録があるユーザか確認.
 *
 * @param {Type} type
 * @param {string} userId
 * @returns
 */
export const getAppUser = (type: Type, userId: string) => {
  // API
  const appUser = AppUserAPI.instance;
  if (appUser === null) {
    return {
      type: AppUser.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return appUser.getAppUser(
    userId,
    () => {
      return {
        type: AppUser.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (status: any, result: any) => {
      switch (status) {
        case AppUser.LOADING:
          return {
            type: AppUser.LOADING,
            result: null,
          };
        case AppUser.ERROR:
          if (result.toString().indexOf('404') > -1) {
            return {
              type: AppUser.ERROR,
              result: null,
            };
          }
          return {
            type: AppUser.ERROR,
            result: result,
          };
        case AppUser.SUCCESS:
          const responseData = result.data as AppUser.ResponseData;
          if (type === Type.HomeVisit) {
            // 居宅訪問.
            return MoffAPI.getHomeVisitRecordCount(responseData.unique_id);
          } else if (type === Type.InterestCheck) {
            // 興味関心チェック.
            return MoffAPI.getInterestCheckRecordCount(responseData.unique_id);
          }

          return null;
        default:
          return {
            type: AppUser.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/AppUser.tsx